import { USER_FROM_CAMPAIGN } from '../event-types';

export function SamplingCampaignCheckAction(message) {
    return {
        type: USER_FROM_CAMPAIGN,
        payload: message,
    };
}
